import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MediaGalleryItem } from '../media-gallery-item/media-gallery-item.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { YoutubeCodeScrapperPipe } from 'src/app/pipes/youtube-code-scrapper/youtube-code-scrapper.pipe';
import { flatMap } from 'rxjs/operators';

@Component({
  selector: 'app-media-gallery-add-video-dialog',
  templateUrl: './media-gallery-add-video-dialog.component.html',
  styleUrls: ['./media-gallery-add-video-dialog.component.scss']
})
export class MediaGalleryAddVideoDialogComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  videos: Array<MediaGalleryItem>;
  url: string;
  errorMessage: string;
  invalid: boolean;

  constructor(public dialogRef: MatDialogRef<MediaGalleryAddVideoDialogComponent>,
              private validationImageService: ValidationImageService,
              private snackbarService: SnackBarService,
              private youtubeCodeScrapperPipe: YoutubeCodeScrapperPipe) {
                this.dialogRef.disableClose = true;
                this.videos = new Array<MediaGalleryItem>();
              }

  ngOnInit() {
  }

  public accept() {
    if (this.validateForm()) {
      if (!(this.videos.length > 0) && this.url) {
        if (this.youtubeCodeScrapperPipe.transform(this.url)) {
          this.videos.push(new MediaGalleryItem(null, this.url, 'VIDEO_YOUTUBE', this.url, this.url, false, 1, null, null, null));
        } else {
          this.videos.push(new MediaGalleryItem(null, this.url, 'VIDEO_URL', this.url, this.url, false, 1, null, null, null));
        }
      }
      this.dialogRef.close(this.videos);
    } else {
      return false;
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public validateForm() {
    if ((this.videos.length > 0) && !this.url) {
      return true;
    } else if (!(this.videos.length > 0) && this.url) {
      return true;
    }
    return false;
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const files = event.target.files;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.validationImageService.toBase64(files[i])
        .pipe(
          flatMap(
            file => this.validationImageService.validateVideoMIMEType(file)
          )
        )
        .subscribe(
          (base64) => {
            this.invalid = false;
            this.errorMessage = null;
            const video = new MediaGalleryItem(null, this.uploadInput.nativeElement.files[i].name, 'VIDEO_FILE', base64, base64, false, 1, null, null, null);
            this.videos.push(video);
          },
          (error) => {
            this.invalid = true;
            this.errorMessage = null;
            this.errorMessage = error;
          }
        );
      }
    }
  }
}
